(() => {
  if (window.valletroHeroVideoInitialized) return;
  window.valletroHeroVideoInitialized = true;
  const instances = new Map();
  const init = hero => {
    if (instances.has(hero)) return;
    const video = hero.querySelector('video');
    const source = video?.querySelector('source');
    if (!source) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const staticOnly = () => motion.matches || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    let visible = false;
    let ready = false;
    let active = '';
    let destroyed = false;
    let timer;
    let idle;
    let raf;
    const play = () => {
      if (destroyed || !ready || !visible || document.hidden || !hero.isConnected || staticOnly()) return;
      const url = mobile.matches ? source.dataset.mobileSrc : source.dataset.desktopSrc;
      if (!url) {
        video.pause();
        video.classList.remove('is-playing');
        if (active) {
          source.removeAttribute('src');
          active = '';
          video.load();
        }
        return;
      }
      if (url !== active) {
        video.pause();
        video.classList.remove('is-playing');
        active = url;
        source.src = url;
        video.load();
      }
      video.play().catch(() => video.classList.remove('is-playing'));
    };
    const playing = () => {
      if (destroyed || staticOnly() || !visible || document.hidden) {
        video.pause();
        video.classList.remove('is-playing');
      } else video.classList.add('is-playing');
    };
    const error = () => video.classList.remove('is-playing');
    const update = () => {
      raf = undefined;
      const shift = mobile.matches || staticOnly() ? 0 : Math.max(-24, Math.min(24, -hero.getBoundingClientRect().top * .08));
      hero.style.setProperty('--hero-shift', `${shift}px`);
    };
    const changed = () => {
      video.pause();
      video.classList.remove('is-playing');
      update();
      play();
    };
    const visibility = () => document.hidden ? video.pause() : play();
    const scroll = () => {
      if (visible && !mobile.matches && !staticOnly() && !raf) raf = window.requestAnimationFrame(update);
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) play(); else video.pause();
    });
    const start = () => {
      timer = window.setTimeout(() => {
        const run = () => { if (!destroyed) { ready = true; play(); } };
        if ('requestIdleCallback' in window) idle = window.requestIdleCallback(run, { timeout: 2000 });
        else run();
      }, 1200);
    };
    video.addEventListener('playing', playing);
    video.addEventListener('error', error);
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('scroll', scroll, { passive: true });
    mobile.addEventListener('change', changed);
    motion.addEventListener('change', changed);
    connection?.addEventListener('change', changed);
    observer.observe(hero);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
    update();
    instances.set(hero, () => {
      destroyed = true;
      observer.disconnect();
      clearTimeout(timer);
      if (idle !== undefined) window.cancelIdleCallback(idle);
      if (raf !== undefined) window.cancelAnimationFrame(raf);
      video.pause();
      window.removeEventListener('load', start);
      window.removeEventListener('scroll', scroll);
      document.removeEventListener('visibilitychange', visibility);
      mobile.removeEventListener('change', changed);
      motion.removeEventListener('change', changed);
      connection?.removeEventListener('change', changed);
      video.removeEventListener('playing', playing);
      video.removeEventListener('error', error);
      instances.delete(hero);
    });
  };
  const initialize = root => root.querySelectorAll('[data-valletro-parallax]').forEach(init);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [hero, cleanup] of instances) if (event.target.contains(hero)) cleanup();
  });
})();
